import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { useCallback } from "react";
import { ListStreams } from "../queries/useListStreams";
import { CopyStreamParams } from "gql/apollo/graphql";

export const CopyStream = graphql(/* GraphQL */ `
	mutation copyStream($params: CopyStreamParams!) {
		copyStream(params: $params) {
			error {
				code
				message
			}
			success
			stream {
				_id
			}
		}
	}
`);

export function useCopyStream() {
	const [copyStream] = useMutation(CopyStream, {
		refetchQueries: [ListStreams, "ListStreams"],
	});

	const handleCopyStream = useCallback(
		async (params: CopyStreamParams) => {
			const result = await copyStream({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.copyStream.success,
				error: result.data?.copyStream.error,
				streamId: result.data?.copyStream.stream?._id,
			};
		},
		[copyStream]
	);

	return { handleCopyStream };
}
